import i18n from 'config/i18n';
import { Dayjs } from 'dayjs';
import { CalculateFunctionType, VatType } from 'generated';
import * as yup from 'yup';

import { getLocale } from 'utils/date';

const getSchema = () => {
  const t = i18n.getFixedT(getLocale(), 'common');

  return yup.object({
    validFrom: yup
      .mixed<Dayjs>()
      .test(
        'dayjs-valid',
        () => t('invalidDate'),
        (v) => (v ? v.isValid() : false)
      )
      .required(),
    validTo: yup
      .mixed<Dayjs>()
      .test(
        'dayjs-valid',
        () => t('invalidDate'),
        (v) => (v ? v.isValid() : false)
      )
      .test(
        'dayjs-min',
        () =>
          t('dateRangeMismatch', {
            startDate: t('validFrom'),
            endDate: t('validTo')
          }),
        (v, ctx) => {
          const validFrom = ctx.parent.validFrom as Dayjs;
          return v && validFrom ? v.isAfter(validFrom) : true;
        }
      )
      .required(),
    functionId: yup.number().optional().nullable(),
    calculateFunctionType: yup.mixed<CalculateFunctionType>().nullable(),
    amount: yup.number().optional(),
    fee: yup.number().optional(),
    vatType: yup.mixed<VatType>().required(t('vatTypeRequired'))
  });
};

export default getSchema;
